import { ReviewClaimConfirmationFormData } from "src/types/forms/claims/reviewClaimConfirmationForm";

export class ReviewClaimConfirmationMapper {
  static initReviewClaimConfirmationFormData(): ReviewClaimConfirmationFormData {
    return {
      claimId: "",
      confirmationMessage: "",
      creditFiles: null
    };
  }
}
